// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-radius: 3px;
}

input {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-radius: 3px;
}

.styles__anchorLink___rJEUl {
  opacity: 0;
  position: relative;
  top: -90px;
  visibility: hidden;
}

.styles__approveButton___pLz3y {
  margin: 10px 14px 0 0;
}

.styles__denyButton___J7GSh {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

#styles__assetGroup___q9qcg .styles__assetSubtype___mF694 {
  margin: 35px 0 10px;
}

#styles__assetGroup___q9qcg .styles__assetSubtype___mF694:first-of-type {
  margin: 20px 0 15px;
}

.styles__buttonLocal___SzR1g {
  margin-right: 20px;
}

#styles__assetGroup___q9qcg .styles__buttonLocal___SzR1g {
  margin-bottom: 20px;
}

.styles__checkbox___y4KaO {
  margin-right: 10px;
}

.styles__checkboxes___R_mTs {
  margin-top: 20px;
}

.styles__contactButtons___DwFPK,
.styles__sectionTitle___aNf2B {
  margin-bottom: 20px;
}

.styles__contactDiv___MGZZx {
  margin-bottom: 30px;
}

.styles__contentContainer___jdEvZ {
}

.styles__distributionGroup___lVELD {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  height: 150px;
  margin: 15px 0;
  padding: 15px;
  width: 100%;
}

.styles__distributionChild___A_1k2 {
  width: 50%;
}

.styles__distributionChild___A_1k2 .styles__radioButtonGroupVertical____CAAn {
  float: left;
  width: 20%;
}

.styles__distributionChild___A_1k2 .styles__description___xjuYH {
  float: right;
  width: 80%;
  height: 120px;
  display: inline;
}

.styles__distributionChild___A_1k2 .styles__description___xjuYH > textarea {
  display: block;
  width: 100%;
  height: 100%;
  text-align: left;
  vertical-align: top;
  box-sizing: border-box;
}

.styles__distributionRemove___C8lw8 {
  float: right;
}

.styles__editContact___m5Pxk {
  margin-bottom: 20px;
  margin-right: 20px;
}

.styles__einDisplay___fYf5T {
}

.styles__einInput___Vj4EQ {
  margin-right: 10px;
}

.styles__fileFoldersDiv___fLWUy {
  min-height: 700px;
}

.styles__grantorButtons___DxcTt {
  margin-top: 20px;
}

.styles__spinner___P3oq_ {
  height: 30px;
  width: 30px;
  background-color: yellow;
}

.styles__form___UYBP9 {
  display: flex;
  flex-flow: column nowrap;
}

.styles__formItem___Bs588 {
}

.styles__formItemHalf___Qgehb {
}

.styles__formItemQuarter___v2CXG {
}

.styles__formWrapper___RY4IO {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__formWrapper___RY4IO:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__formWrapper___RY4IO:last-child {
  margin-right: 0;
}

.styles__formWrapper___RY4IO:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__formWrapper___RY4IO:nth-child(3n + 1) {
  clear: both;
}

.styles__saveButton___w3kY1 {
  float: right;
}

.styles__headerSection___xSnR7 {
  min-height: 80px;
}

.styles__headerTitle___oLT7P {
  float: left;
}

.styles__headerStatus___m8fAy {
  float: right;
  text-align: right;
}

.styles__headerStatus___m8fAy h5 {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]};
  border-radius: 3px;
  display: inline-block;
  margin-top: 6px;
  padding: 4px;
  vertical-align: middle;
}

.styles__headerStatus___m8fAy h5 a {
  color: white;
}

.styles__incomeAssetGroup___RIljk {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  height: 60px;
  margin: 15px 0;
  padding: 15px;
  width: 700px;
}

.styles__incomeAsset___xUccH {
  width: 50%;
}

.styles__incomeAsset___xUccH label {
  margin-right: 8px;
}

.styles__incomeAsset___xUccH input {
  height: 30px;
  padding: 3px;
}

.styles__incomeAsset___xUccH:first-child {
  float: left;
  width: 70%;
}

.styles__incomeAsset___xUccH:first-child input {
  width: 80%;
}

.styles__incomeAsset___xUccH:nth-child(2) {
  float: right;
  width: 30%;
}

.styles__incomeAsset___xUccH .styles__incomeAssetAmount___iPeqQ {
  width: 60%;
}

.styles__incomeAssetRemoveButton___Tj5Qr {
  float: right;
}

.styles__label___LRica {
  color: #555;
  font-size: 13px;
}

.styles__selectLabel___WOacH {
  margin-right: 10px;
}

.styles__link___qywCp {
  background: rgba(255, 255, 255, 0.7);
  box-shadow: none;
  display: block;
}

.styles__link___qywCp:hover {
    background: white;
    box-shadow: none;
  }

.styles__menuLink___JzQit {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  display: flex;
  align-self: center;
}

.styles__menuSection___ZfMbE {
  margin-bottom: 20px;
}

.styles__menuWrapper___AffUt {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__menuWrapper___AffUt:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__menuWrapper___AffUt:last-child {
  margin-right: 0;
}

.styles__menuWrapper___AffUt:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__menuWrapper___AffUt:nth-child(3n + 1) {
  clear: both;
}

.styles__navigationSave___GZMXN {
  float: left;
  padding-left: 5px;
  padding-top: 20px;
}

.styles__navigationMenuWrapper___XyBmu {
  position: fixed;
  width: 452.86px;
}

@media (max-width: 1440px) {

.styles__navigationMenuWrapper___XyBmu {
    max-width: 31%;
    right: 20px;
}
  }
.styles__scrollArea___GacLw {
  overflow-y: scroll;
  height: 80vh;
}
.styles__notesTextArea___r2JHn {
  width: 100%;
  min-height: 90px;
}

.styles__potentialClientRemoveButton___YXAKR {
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-shadow: none;
}

.styles__radioButtonGroup___faNZi {
  margin-top: 20px;
  margin-bottom: 10px;
}

.styles__radioButtonGroup___faNZi label {
  font-size: 14px;
}

.styles__radioButtonGroup___faNZi .styles__buttons___mD4xP {
  margin-top: 5px;
}

.styles__radioButtonGroup___faNZi .styles__buttons___mD4xP input:first-child {
  margin-top: 10px;
  margin-right: 10px;
  margin-left: 0;
}

.styles__radioButtonGroup___faNZi .styles__buttons___mD4xP input {
  margin-top: 10px;
  margin-right: 10px;
  margin-left: 20px;
}

.styles__radioButtonGroupVertical____CAAn {
  width: 150px;
  display: block;
  padding: 0 0 5px 5px;
  clear: both;
}

.styles__distributionChild___A_1k2 {
  float: left;
  width: 70%;
}

.styles__radioButtonGroupVertical____CAAn span {
  display: block;
  padding-left: 20px;
  padding-bottom: 10px;
  cursor: inherit;
}

.styles__radioButtonGroupVertical____CAAn label {
  font-size: rem-calc(16);
  padding-left: 5px;
  padding-bottom: 10px;
}

.styles__radioButtonGroupVertical____CAAn input {
  float: left;
  width: 20px;
  margin-left: -20px;
  padding: 0;
  -webkit-appearance: radio;
}

.styles__removeButton___xuFzA {
}

.styles__reviewNotes___tMlsi > textarea {
  display: block;
  width: 50%;
  height: 100px;
  margin: 10px 0;
  text-align: left;
  vertical-align: top;
  box-sizing: border-box;
}

.styles__reviewNotes___tMlsi > textarea::placeholder {
    opacity: 0.7;
  }

.styles__reviewNotes___tMlsi .styles__hidden____uwNu {
  visibility: hidden;
  height: 0;
}

.styles__row___ELplM {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.styles__section_____GGk {
}

.styles__select___CXpLT {
  margin-top: 10px;
  width: 50%;
}

.styles__selectGroup___XeTJ8 {
}

.styles__textInputGroup___wLOZG {
  margin-top: 20px;
}

.styles__textInputGroup___wLOZG input {
  margin-left: 7px;
  height: 30px;
  padding: 3px;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-radius: 3px;
  width: 385px;
}

.styles__textInputGroup___wLOZG .styles__currencyInput___ueSKo {
  width: 125px;
}

.styles__trustRadioNotes___mCbJ4 > textarea {
  display: block;
  width: 100%;
  height: 120px;
  margin-top: 20px;
  text-align: left;
  vertical-align: top;
  box-sizing: border-box;
}

.styles__trustRadioNotes___mCbJ4 > textarea::placeholder {
    opacity: 0.7;
  }

.styles__trustRadioNotes___mCbJ4 .styles__hidden____uwNu {
  visibility: hidden;
  height: 0;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/PotentialClient/components/Edit/styles.css"],"names":[],"mappings":"AAIA;EACE,8DAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,8DAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,8DAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;EACE,8DAAwB;EACxB,aAAa;EACb,cAAc;EACd,aAAa;EACb,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EAGnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAA2B;EAA3B,wBAA2B;AAC7B;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EAEE,YAAY;AACd;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wDAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8DAAwB;EACxB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EAGE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAEhB,cAAc;AAMhB;;AAJE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,mDAAc;EAEd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;AAMjB;;AAJE;;AAJF;IAKI,cAAc;IACd,WAAW;AAEf;EADE;AAEF;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6BAAqB;EAArB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;AAEA;;AAEA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EAGnB,sBAAsB;AAKxB;;AAHE;IACE,YAAY;EACd;;AAGF;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;AAEA;;AAEA;EAEE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;AAEA;;AAEA;EACE,gBAAgB;AAElB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,8DAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EAGnB,sBAAsB;AAKxB;;AAHE;IACE,YAAY;EACd;;AAGF;EACE,kBAAkB;EAClB,SAAS;AACX","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGPT, gtGray, gtGrayMid, gtGreen, gtBlue, gtRed from colors;\n\ntextarea {\n  border: 1px solid gtGray;\n  border-radius: 3px;\n}\n\ninput {\n  border: 1px solid gtGray;\n  border-radius: 3px;\n}\n\n.anchorLink {\n  opacity: 0;\n  position: relative;\n  top: -90px;\n  visibility: hidden;\n}\n\n.approveButton {\n  composes: button from helpers;\n  margin: 10px 14px 0 0;\n}\n\n.denyButton {\n  composes: approveButton;\n  background-color: gtRed;\n}\n\n#assetGroup .assetSubtype {\n  margin: 35px 0 10px;\n}\n\n#assetGroup .assetSubtype:first-of-type {\n  margin: 20px 0 15px;\n}\n\n.buttonLocal {\n  composes: buttonLocal from helpers;\n  margin-right: 20px;\n}\n\n#assetGroup .buttonLocal {\n  margin-bottom: 20px;\n}\n\n.checkbox {\n  margin-right: 10px;\n}\n\n.checkboxes {\n  margin-top: 20px;\n}\n\n.contactButtons,\n.sectionTitle {\n  margin-bottom: 20px;\n}\n\n.contactDiv {\n  margin-bottom: 30px;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n}\n\n.distributionGroup {\n  border: 1px solid gtGray;\n  height: 150px;\n  margin: 15px 0;\n  padding: 15px;\n  width: 100%;\n}\n\n.distributionChild {\n  width: 50%;\n}\n\n.distributionChild .radioButtonGroupVertical {\n  float: left;\n  width: 20%;\n}\n\n.distributionChild .description {\n  float: right;\n  width: 80%;\n  height: 120px;\n  display: inline;\n}\n\n.distributionChild .description > textarea {\n  display: block;\n  width: 100%;\n  height: 100%;\n  text-align: left;\n  vertical-align: top;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.distributionRemove {\n  float: right;\n}\n\n.editContact {\n  composes: buttonSecondary from helpers;\n  margin-bottom: 20px;\n  margin-right: 20px;\n}\n\n.einDisplay {\n  composes: clearfix from helpers;\n}\n\n.einInput {\n  margin-right: 10px;\n}\n\n.fileFoldersDiv {\n  min-height: 700px;\n}\n\n.grantorButtons {\n  composes: clearfix from helpers;\n  margin-top: 20px;\n}\n\n.spinner {\n  height: 30px;\n  width: 30px;\n  background-color: yellow;\n}\n\n.form {\n  lost-flex-container: column;\n}\n\n.formItem {\n  composes: formItem from helpers;\n}\n\n.formItemHalf {\n  composes: formItemHalf from helpers;\n}\n\n.formItemQuarter {\n  composes: formItemQuarter from helpers;\n}\n\n.formWrapper {\n  lost-column: 2/3;\n}\n\n.saveButton {\n  composes: button from helpers;\n  float: right;\n}\n\n.headerSection {\n  composes: section from helpers;\n  min-height: 80px;\n}\n\n.headerTitle {\n  float: left;\n}\n\n.headerStatus {\n  float: right;\n  text-align: right;\n}\n\n.headerStatus h5 {\n  background: gtGPT;\n  border-radius: 3px;\n  display: inline-block;\n  margin-top: 6px;\n  padding: 4px;\n  vertical-align: middle;\n}\n\n.headerStatus h5 a {\n  color: white;\n}\n\n.incomeAssetGroup {\n  border: 1px solid gtGray;\n  height: 60px;\n  margin: 15px 0;\n  padding: 15px;\n  width: 700px;\n}\n\n.incomeAsset {\n  width: 50%;\n}\n\n.incomeAsset label {\n  margin-right: 8px;\n}\n\n.incomeAsset input {\n  height: 30px;\n  padding: 3px;\n}\n\n.incomeAsset:first-child {\n  float: left;\n  width: 70%;\n}\n\n.incomeAsset:first-child input {\n  width: 80%;\n}\n\n.incomeAsset:nth-child(2) {\n  float: right;\n  width: 30%;\n}\n\n.incomeAsset .incomeAssetAmount {\n  width: 60%;\n}\n\n.incomeAssetRemoveButton {\n  float: right;\n}\n\n.label {\n  composes: label from helpers;\n  color: #555;\n  font-size: 13px;\n}\n\n.selectLabel {\n  composes: label;\n  composes: clearfix from helpers;\n  margin-right: 10px;\n}\n\n.link {\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: none;\n  composes: sectionTitle from helpers;\n  display: block;\n\n  &:hover {\n    background: white;\n    box-shadow: none;\n  }\n}\n\n.menuLink {\n  color: gtGreen;\n  composes: link;\n  display: flex;\n  align-self: center;\n}\n\n.menuSection {\n  composes: sectionTitle from helpers;\n  margin-bottom: 20px;\n}\n\n.menuWrapper {\n  lost-column: 1/3;\n}\n\n.navigationSave {\n  float: left;\n  padding-left: 5px;\n  padding-top: 20px;\n}\n\n.navigationMenuWrapper {\n  position: fixed;\n  width: 452.86px;\n\n  @media (max-width: 1440px) {\n    max-width: 31%;\n    right: 20px;\n  }\n}\n.scrollArea {\n  overflow-y: scroll;\n  height: 80vh;\n}\n.notesTextArea {\n  width: 100%;\n  min-height: 90px;\n}\n\n.potentialClientRemoveButton {\n  border: none;\n  color: #ccc;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 700;\n  text-decoration: none;\n  text-shadow: none;\n}\n\n.radioButtonGroup {\n  composes: clearfix from helpers;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.radioButtonGroup label {\n  font-size: 14px;\n}\n\n.radioButtonGroup .buttons {\n  margin-top: 5px;\n}\n\n.radioButtonGroup .buttons input:first-child {\n  margin-top: 10px;\n  margin-right: 10px;\n  margin-left: 0;\n}\n\n.radioButtonGroup .buttons input {\n  margin-top: 10px;\n  margin-right: 10px;\n  margin-left: 20px;\n}\n\n.radioButtonGroupVertical {\n  width: 150px;\n  display: block;\n  padding: 0 0 5px 5px;\n  clear: both;\n}\n\n.distributionChild {\n  float: left;\n  width: 70%;\n}\n\n.radioButtonGroupVertical span {\n  display: block;\n  padding-left: 20px;\n  padding-bottom: 10px;\n  cursor: inherit;\n}\n\n.radioButtonGroupVertical label {\n  font-size: rem-calc(16);\n  padding-left: 5px;\n  padding-bottom: 10px;\n}\n\n.radioButtonGroupVertical input {\n  float: left;\n  width: 20px;\n  margin-left: -20px;\n  padding: 0;\n  -webkit-appearance: radio;\n}\n\n.removeButton {\n  composes: removeButton from helpers;\n}\n\n.reviewNotes > textarea {\n  display: block;\n  width: 50%;\n  height: 100px;\n  margin: 10px 0;\n  text-align: left;\n  vertical-align: top;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n  &::placeholder {\n    opacity: 0.7;\n  }\n}\n\n.reviewNotes .hidden {\n  visibility: hidden;\n  height: 0;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.section {\n  composes: section from helpers;\n}\n\n.select {\n  composes: select from helpers;\n  margin-top: 10px;\n  width: 50%;\n}\n\n.selectGroup {\n  composes: clearfix from helpers;\n}\n\n.textInputGroup {\n  margin-top: 20px;\n  composes: clearfix from helpers;\n}\n\n.textInputGroup input {\n  margin-left: 7px;\n  height: 30px;\n  padding: 3px;\n  border: 1px solid gtGray;\n  border-radius: 3px;\n  width: 385px;\n}\n\n.textInputGroup .currencyInput {\n  width: 125px;\n}\n\n.trustRadioNotes > textarea {\n  display: block;\n  width: 100%;\n  height: 120px;\n  margin-top: 20px;\n  text-align: left;\n  vertical-align: top;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n  &::placeholder {\n    opacity: 0.7;\n  }\n}\n\n.trustRadioNotes .hidden {\n  visibility: hidden;\n  height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGPT": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayMid": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"anchorLink": `styles__anchorLink___rJEUl`,
	"approveButton": `styles__approveButton___pLz3y ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"denyButton": `styles__denyButton___J7GSh styles__approveButton___pLz3y ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"assetGroup": `styles__assetGroup___q9qcg`,
	"assetSubtype": `styles__assetSubtype___mF694`,
	"buttonLocal": `styles__buttonLocal___SzR1g ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonLocal"]}`,
	"checkbox": `styles__checkbox___y4KaO`,
	"checkboxes": `styles__checkboxes___R_mTs`,
	"contactButtons": `styles__contactButtons___DwFPK`,
	"sectionTitle": `styles__sectionTitle___aNf2B`,
	"contactDiv": `styles__contactDiv___MGZZx`,
	"contentContainer": `styles__contentContainer___jdEvZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"distributionGroup": `styles__distributionGroup___lVELD`,
	"distributionChild": `styles__distributionChild___A_1k2`,
	"radioButtonGroupVertical": `styles__radioButtonGroupVertical____CAAn`,
	"description": `styles__description___xjuYH`,
	"distributionRemove": `styles__distributionRemove___C8lw8`,
	"editContact": `styles__editContact___m5Pxk ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"einDisplay": `styles__einDisplay___fYf5T ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"einInput": `styles__einInput___Vj4EQ`,
	"fileFoldersDiv": `styles__fileFoldersDiv___fLWUy`,
	"grantorButtons": `styles__grantorButtons___DxcTt ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"spinner": `styles__spinner___P3oq_`,
	"form": `styles__form___UYBP9`,
	"formItem": `styles__formItem___Bs588 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItem"]}`,
	"formItemHalf": `styles__formItemHalf___Qgehb ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemHalf"]}`,
	"formItemQuarter": `styles__formItemQuarter___v2CXG ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemQuarter"]}`,
	"formWrapper": `styles__formWrapper___RY4IO`,
	"saveButton": `styles__saveButton___w3kY1 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"headerSection": `styles__headerSection___xSnR7 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"headerTitle": `styles__headerTitle___oLT7P`,
	"headerStatus": `styles__headerStatus___m8fAy`,
	"incomeAssetGroup": `styles__incomeAssetGroup___RIljk`,
	"incomeAsset": `styles__incomeAsset___xUccH`,
	"incomeAssetAmount": `styles__incomeAssetAmount___iPeqQ`,
	"incomeAssetRemoveButton": `styles__incomeAssetRemoveButton___Tj5Qr`,
	"label": `styles__label___LRica ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"selectLabel": `styles__selectLabel___WOacH styles__label___LRica ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"link": `styles__link___qywCp ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"menuLink": `styles__menuLink___JzQit styles__link___qywCp ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"menuSection": `styles__menuSection___ZfMbE ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"menuWrapper": `styles__menuWrapper___AffUt`,
	"navigationSave": `styles__navigationSave___GZMXN`,
	"navigationMenuWrapper": `styles__navigationMenuWrapper___XyBmu`,
	"scrollArea": `styles__scrollArea___GacLw`,
	"notesTextArea": `styles__notesTextArea___r2JHn`,
	"potentialClientRemoveButton": `styles__potentialClientRemoveButton___YXAKR`,
	"radioButtonGroup": `styles__radioButtonGroup___faNZi ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"buttons": `styles__buttons___mD4xP`,
	"removeButton": `styles__removeButton___xuFzA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["removeButton"]}`,
	"reviewNotes": `styles__reviewNotes___tMlsi`,
	"hidden": `styles__hidden____uwNu`,
	"row": `styles__row___ELplM`,
	"section": `styles__section_____GGk ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"select": `styles__select___CXpLT ${___CSS_LOADER_ICSS_IMPORT_1___.locals["select"]}`,
	"selectGroup": `styles__selectGroup___XeTJ8 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"textInputGroup": `styles__textInputGroup___wLOZG ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"currencyInput": `styles__currencyInput___ueSKo`,
	"trustRadioNotes": `styles__trustRadioNotes___mCbJ4`
};
export default ___CSS_LOADER_EXPORT___;
